export default "__VITE_ASSET__BoNdKgaD__"